import { render, staticRenderFns } from "./crownMultiselect.vue?vue&type=template&id=bcd827ec&scoped=true&"
import script from "./crownMultiselect.vue?vue&type=script&lang=js&"
export * from "./crownMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./crownMultiselect.vue?vue&type=style&index=0&id=bcd827ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd827ec",
  null
  
)

export default component.exports